import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard")({
  // The authenticated `/dashboard/**` subtree stays client-only (D-216-5:
  // only public/SEO routes server-render). `defaultSsr: false` already covers
  // it, but the explicit flag guards against a router-default change: cascaded
  // to every child, it keeps their `beforeLoad`/`loader` hooks — which make
  // authenticated tRPC calls like `getEntryWorkspace()` — off the server,
  // where Firebase auth doesn't exist and those calls would go out with an
  // empty Authorization token and surface as an SSR 500 instead of the clean
  // client-side redirect below.
  ssr: false,
  beforeLoad: ({ context }) => {
    // Only redirect once Firebase auth has resolved. During SSR and the
    // initial client route (before `initAuth()` fires), `user` is null but
    // `isLoading` is true — redirecting then would bounce signed-in users to
    // /login, and `router.invalidate()` after auth resolves can't recover a
    // navigation that already happened. While auth is unresolved the loading
    // branch renders the dashboard shell and the client corrects it.
    if (!context.auth.isLoading && !context.auth.user) {
      throw redirect({ to: "/login" });
    }
  },
  component: DashboardOutlet,
});

function DashboardOutlet() {
  return <Outlet />;
}
